import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class NoRights extends Component {
  render() {
    return (
      <h3 className="p-3">
        <FormattedMessage id="messages.no_rights" />
      </h3>
    );
  }
}

export { NoRights };
